"use client";
import React, { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import "./ImageSlider.css";

const ImageSlider = ({ images, onImageClick }) => {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkScreen = () => {
      setIsDesktop(window.innerWidth >= 1024); // Tailwind's lg: 1024px
    };
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const options = {
    loop: true,
    skipSnaps: false,
    containScroll: "trimSnaps",
    dragFree: false,
    duration: 25, // Smooth transition duration
    startIndex: 0,
    align: "start",
    slidesToScroll: 1,
    watchDrag: true,
  };

  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Simple autoplay with setInterval
  useEffect(() => {
    if (!emblaApi || !images || images.length <= 1) return;

    const autoplayInterval = setInterval(() => {
      if (emblaApi.canScrollNext()) {
        emblaApi.scrollNext();
      } else {
        emblaApi.scrollTo(0); // Loop back to start
      }
    }, 3000); // 3 seconds between slides

    return () => {
      clearInterval(autoplayInterval);
    };
  }, [emblaApi, images]);

  const handleSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.on("select", handleSelect);
    handleSelect(); // Set initial state

    return () => {
      emblaApi.off("select", handleSelect);
    };
  }, [emblaApi, handleSelect]);

  // const nextSlide = useCallback(() => {
  //   if (emblaApi && emblaApi.canScrollNext()) {
  //     emblaApi.scrollNext();
  //   }
  // }, [emblaApi]);

  // const prevSlide = useCallback(() => {
  //   if (emblaApi && emblaApi.canScrollPrev()) {
  //     emblaApi.scrollPrev();
  //   }
  // }, [emblaApi]);

  const renderDots = () => (
    <div className="flex justify-center mt-4 space-x-2">
      {images.map((_, index) => (
        <button
          key={index}
          onClick={() => emblaApi?.scrollTo(index)}
          className={`dot-indicator w-3 h-3 rounded-full ${
            index === selectedIndex
              ? "bg-blue-600 active"
              : "bg-gray-300 hover:bg-gray-400"
          }`}
          aria-label={`Slide ${index + 1}`}
        />
      ))}
    </div>
  );

  return (
    <div className="embla relative w-full overflow-hidden">
      <div className="embla__container relative w-full h-full" ref={emblaRef}>
        <div className="flex">
          {images.map((image, index) => (
            <div
              key={index}
              className="embla__slide flex-shrink-0 w-full sm:w-2/3 md:w-1/2 lg:w-1/3 p-2"
            >
              <div className="overflow-hidden rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl border border-blue-500/10 sm:border-2 sm:border-blue-500/20 bg-gradient-to-br from-white to-blue-50 dark:from-gray-800 dark:to-gray-700">
                <div
                  className="h-64 sm:h-[320px] md:h-[400px] lg:h-[480px] w-full overflow-hidden relative cursor-pointer group"
                  onClick={() => onImageClick && onImageClick(image)}
                >
                  <img
                    src={image.src}
                    alt={image.title || `Gallery image ${index + 1}`}
                    className="w-full h-full object-cover image-scale-hover"
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?fit=crop&w=800&h=600&q=80";
                    }}
                  />
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 overlay-transition flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 overlay-transition bg-white/20 backdrop-blur-sm rounded-full p-2 transform scale-75 group-hover:scale-100">
                      <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

{/* Navigation Arrows */}
        {/* <button
          onClick={prevSlide}
          className="slider-button absolute left-2 sm:left-4 md:left-6 top-1/2 transform -translate-y-1/2 bg-blue-500 dark:bg-blue-700 text-white text-2xl sm:text-3xl md:text-4xl font-bold p-2 rounded-full shadow-md w-10 h-10 md:w-12 md:h-12 flex items-center justify-center hover:bg-blue-600 hover:shadow-lg"
          aria-label="Previous slide"
        >
          &#10094;
        </button>
        <button
          onClick={nextSlide}
          className="slider-button absolute right-2 sm:right-4 md:right-6 top-1/2 transform -translate-y-1/2 bg-blue-500 dark:bg-blue-700 text-white text-2xl sm:text-3xl md:text-4xl font-bold p-2 rounded-full shadow-md w-10 h-10 md:w-12 md:h-12 flex items-center justify-center hover:bg-blue-600 hover:shadow-lg"
          aria-label="Next slide"
        >
          &#10095;
        </button> */}
      </div>
      {renderDots()}
    </div>
  );
};

export default ImageSlider;
